import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import {
	fetchLogicsConfiguration,
	resetLogics,
	selectCommitRefs,
	selectLogics,
} from "../../../../logics/logicsSlice";
import {
	WindowTypeAndPropsDefinition,
	closeWindow,
} from "../../../windowManagerSlice";
import css from "./LogicsMigrationWindow.module.css";

export interface LogicsMigrationWindowProps {}

export type LogicsMigrationWindowTypeAndProps = WindowTypeAndPropsDefinition<
	"logicsMigration",
	LogicsMigrationWindowProps
>;

export function LogicsMigrationWindow(
	props: LogicsMigrationWindowProps & { id: string },
) {
	const dispatch = useAppDispatch();
	const commitRefs = useAppSelector(selectCommitRefs);
	const logics = useAppSelector(selectLogics);
	const isDevModeActive = useAppSelector((state) => state.system.devMode);
	const commitByHash = commitRefs.findIndex(
		(ref) => ref.hash === logics.commit.hash,
	);
	const previousCommit =
		commitByHash !== -1
			? commitByHash
			: commitRefs.findIndex((ref) => ref.name === logics.commit.name);

	const [selectedCommitIndex, setSelectedCommitIndex] =
		useState<number>(previousCommit);

	return (
		<div className={css.content}>
			<div className={css.selectorInfo}>
				Please select which logics version you would like to migrate to.
			</div>
			<select
				className={css.selectorSelect}
				value={selectedCommitIndex}
				onChange={(event) => {
					setSelectedCommitIndex(Number(event.target.value));
				}}
			>
				{commitRefs
					.map((ref, index) => (
						<option key={`${ref.hash}-${ref.name}`} value={index}>
							{ref.name.startsWith("JSON_")
								? `Firmware ${ref.name.slice(5)}`
								: ref.name}{" "}
							{ref.datasetVersion && ` / Dataset V${ref.datasetVersion}`}
						</option>
					))
					.filter((_, index) => {
						if (isDevModeActive) {
							return true;
						}

						return commitRefs[index].name.startsWith("JSON_");
					})}
			</select>
			<button
				className={css.migrateButton}
				onClick={() => {
					dispatch(closeWindow(props.id));
					dispatch(resetLogics());
					dispatch(
						fetchLogicsConfiguration({
							...commitRefs[selectedCommitIndex],
							migrate: true,
						}),
					);
				}}
			>
				Migrate
			</button>
		</div>
	);
}
